import styled from 'styled-components/macro';

export const StyledFieldWrapper = styled.div`
  margin: 1rem 0;
`;
